<template>
  <div class="container_notLogin_admin">
    <div class="header_title">
      <div style="font-size: 23px">
        武术赛事报名系统<span style="font-size: 15px; margin-left: 15px"
          >V3.0</span
        >
      </div>
      <el-button @click="$router.push('/register')">注册账号</el-button>
    </div>
    <div class="main_admin">
      <custom-table
        ref="table"
        :border="true"
        :data="tableData"
        :page="page"
        :tableItemConfig="tableItemConfig"
        :show-page-box="false"
        :height="0"
        :showSearchBox="false"
      >
      </custom-table>
    </div>
    <div
      style="
        position: absolute;
        bottom: 20px;
        font-size: 13px;
        color: #555555;
        z-index: 999;
      "
    >
      Copyright © 广州市圆和文化传播有限公司 粤ICP备18042752号-1
    </div>
    <Modal
      title="规程文件"
      v-model="editTableItemVisible"
      width="60%"
      footer-hide
    >
      <gui-cheng-list :competitionInfo="competitionInfo" />
    </Modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CustomTable from "@/components/CustomTable.vue";
import { listCompetition } from "@/api";
import CommonTool from "@/views/util/CommonTool";
import moment from "moment/moment";
import GuiChengList from "@/views/GuiChengList.vue";
import { MessageBox, Message } from "element-ui";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  components: { GuiChengList, CustomTable },
  data() {
    return {
      competitionInfo: "",
      editTableItemVisible: false,
      tableData: [],
      tableItemConfig: [
        CommonTool.createTableListItem("赛事名称", "eventName", (item) => {
          item.width = 0;
          item.enableSearch = true;
          item.align = "left";
          return item;
        }),
        CommonTool.createTableListItem("报名开始时间", "startTime", (item) => {
          item.width = 220;
          item.enableSearch = true;
          item.render = (h, params) => {
            return h(
              "span",
              {
                style: {},
              },
              moment(params.row[params.column.key]).format("YYYY-MM-DD")
            );
          };
          return item;
        }),
        CommonTool.createTableListItem("报名截止时间", "endTime", (item) => {
          item.width = 220;
          item.enableSearch = true;
          item.render = (h, params) => {
            return h(
              "span",
              {
                style: {},
              },
              moment(params.row[params.column.key]).format("YYYY-MM-DD")
            );
          };
          return item;
        }),
        CommonTool.createTableListItem("操作", "cz", (item) => {
          item.width = 220;
          item.enableSearch = true;
          item.render = (h, params) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "primary",
                    size: "mini",
                  },
                  style: {
                    fontSize: "12px",
                  },
                  on: {
                    click: () => {
                      this.handleJoin(params.row);
                    },
                  },
                },
                "进入报名"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "primary",
                    size: "mini",
                  },
                  style: {
                    fontSize: "12px",
                  },
                  on: {
                    click: () => {
                      this.competitionInfo = params.row;
                      this.editTableItemVisible = true;
                    },
                  },
                },
                "查看规程"
              ),
            ]);
          };
          return item;
        }),
      ],
      page: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      searchForm: {},
    };
  },
  created() {
    this.loadList();
  },
  mounted() {
    this.$store.dispatch("setEventInfo", null);
  },
  computed: {
    ...mapState(["screenHeight", "screenWidth"]),
  },
  methods: {
    handleJoin(row) {
      console.log(row);
      this.$store.dispatch("setEventInfo", row);
      this.$router.push({
        path: "/login",
      });
    },
    loadList() {
      listCompetition({
        pageSize: 2000,
        pageNum: 1,
        auditStatus: 1,
        status: 1,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.page.total = res.data.result.total;
            this.tableData = res.data.result.records;
          } else {
            Message.error("请求失败!");
          }
        })
        .catch(() => {
          Message.error("加载列表数据失败");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container_notLogin_admin {
  width: 100vw;
  min-height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;

  .header_title {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #f7f8fc;
    padding-left: 20px;
    padding-right: 20px;
  }

  .main_admin {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
</style>
